import { proxy } from 'valtio';

import { DiagramComponentInstance, DiagramConnection } from 'models';

const copyPasteSpecificationsState = proxy<{
    componentInstance: DiagramComponentInstance | null;
    connection: DiagramConnection | null;
}>({
    componentInstance: null,
    connection: null,
});

export { copyPasteSpecificationsState };
